import Navbar from "./Navbar";

const SHOW_NAVBAR = false;

export default function Hero() {
  return (
    <section className="relative w-full h-screen min-h-[640px] overflow-hidden">
      {/* Background video */}
      <video
        src="https://public.readdy.ai/ai/video_res/019ece81-999e-71e3-8b2f-6c58f2f00845.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover object-center"
      />

      {SHOW_NAVBAR ? <Navbar /> : null}

      {/* Hero text — centered vertically around mid-screen */}
      <div className="font-modern relative z-10 px-6 md:px-12 lg:px-16 pt-[30vh] md:pt-[28vh] max-w-3xl">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-neutral-900/60"></span>
          <span className="text-neutral-700 text-xs tracking-[0.35em] uppercase font-medium">
            沐燁文化 · MOYA · 官方網站
          </span>
        </div>

        <h1 className="text-neutral-900 text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight font-bold">
          沐燁文化 <br />
          <span className="font-display italic font-light text-neutral-800 tracking-normal">MOYA</span>
        </h1>

        <p className="mt-8 text-neutral-600 text-base md:text-lg leading-relaxed max-w-md font-normal">
          以 AIGC 彩色書籍與史密森學會相關科普內容為主要出版方向，透過圖像與文字呈現自然、科學及知識主題。
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <a
            href="https://catalog.sonbook.net/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-neutral-900 text-white px-7 py-3.5 rounded-full text-sm tracking-[0.15em] hover:bg-neutral-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            前往書籍資料庫
            <i className="ri-external-link-line"></i>
          </a>
          <a
            href="https://sonbook.net/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-neutral-900 text-sm tracking-[0.15em] group cursor-pointer whitespace-nowrap"
          >
            <span className="w-10 h-10 rounded-full border border-neutral-900/50 flex items-center justify-center group-hover:bg-neutral-900/10 transition-colors">
              <i className="ri-arrow-right-line text-base"></i>
            </span>
            前往崧博出版
          </a>
        </div>
      </div>
    </section>
  );
}